<script>
import dataView from 'src/modules/pages/view'
import contentPage from './components/view'
export default {
  mixins: [dataView],
  name: "timekeeping",
  data() {
    return {
      route: 'Timekeeping',
    }
  },
  created() {
  },
  components: {
    'contentPage' : contentPage
  }
}
</script>
